import LazyLoad from 'react-lazyload';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import Typography from '@alltrails/shared/denali/components/Typography';
import GooglePlay from '@alltrails/shared/components/storeBadges/GooglePlay';
import AppStore from '@alltrails/shared/components/storeBadges/AppStore';
import * as styles from './styles/styles.module.scss';

type AppForOutdoorsProps = {
  languageRegionCode?: LanguageRegionCode;
  noReferrerAppLinks?: boolean;
};

const AppForOutdoors = ({ languageRegionCode = LanguageRegionCode.English, noReferrerAppLinks = true }: AppForOutdoorsProps) => (
  <div className={styles.container}>
    <div className={styles.title}>
      <Typography component="h2" variant="text300bold" color="inverse" data-testid="app-for-the-outdoors">
        <FormattedMessage defaultMessage="An app for the outdoors" />
      </Typography>
    </div>
    <div className={styles.appIconsContainer}>
      <LazyLoad>
        <AppStore height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} />
        <GooglePlay height={35} className={styles.appIcon} languageRegionCode={languageRegionCode} noReferrer={noReferrerAppLinks} />
      </LazyLoad>
    </div>
  </div>
);

export default AppForOutdoors;
